import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { ModalDetailPropriedadePage } from './modal-detail-propriedade.page';

const routes: Routes = [
  {
    path: '',
    component: ModalDetailPropriedadePage
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class ModalDetailPropriedadePageRoutingModule {}
